import React from "react";
import SeoHead from "../components/Seo/SeoHead";
import ScrapbookEditor from "../components/Scrapbook/ScrapbookEditor";

const ScrapbookPage = () => (
	<>
		<SeoHead
			title="Crea tu álbum de viaje — Viajes Molones"
			description="Diseña páginas de scrapbook con tus fotos de viaje. Plantillas bonitas, stickers y fondos para crear recuerdos que puedes descargar para Instagram Stories."
			path="/album"
		/>
		<ScrapbookEditor />
	</>
);

export default ScrapbookPage;
